"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.isTouchDevice = void 0;
var isTouch = undefined;

var isTouchDevice = function isTouchDevice() {
  var win = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window;

  if (isTouch !== undefined) {
    return isTouch;
  }

  var hasTouchStart = ('ontouchstart' in win);
  isTouch = !!(typeof win !== 'undefined' && (hasTouchStart || win.DocumentTouch && typeof win.document !== 'undefined' && win.document instanceof win.DocumentTouch)) || !!(typeof win.navigator !== 'undefined' && (win.navigator.maxTouchPoints || win.navigator.msMaxTouchPoints));
  return isTouch;
};

exports.isTouchDevice = isTouchDevice;